export const USER_ROUTES = {
  list: '/users',
  detail: (userId: number | string) => `/users/${userId}`,
  edit: (userId: number | string) => `/users/${userId}/edit`,
  bodyTab: (userId: number | string) => `/users/${userId}?tab=body`,
  newMeasurement: (userId: number | string) =>
    `/users/${userId}?tab=body&mode=new-measurement`,
} as const;
